import React from "react";
import styled, { css } from "styled-components";
import {
  Dialog as MuiDialog,
  DialogContent as MuiDialogContent,
  Divider as MuiDivider,
  IconButton, Switch, withStyles
} from "@material-ui/core";

export const Dialog = styled(MuiDialog)`
	.MuiPaper-root {
		background: ${props => props.theme.palette.primary.main};
		box-shadow: none;
		max-width: unset;
		padding: ${props => props.theme.widthRatio*24}px
		         ${props => props.theme.widthRatio*20}px
		         ${props => props.theme.widthRatio*30}px
		         ${props => props.theme.widthRatio*20}px;
		align-items: center;
		border-radius: ${props => props.theme.widthRatio*10}px;
		position: relative;
		margin-left: ${props => props.theme.widthRatio * 280}px;
		
    ${props => props.theme.name === 'dark' && css`
      border: 1px solid ${props => props.theme.palette.secondary.main};
    `}
  
    ${props => props.theme.name === 'light' && css`
      box-shadow: 0 2px 32px 4px rgba(0,0,0,0.2);
    `}
	}
	
	.MuiBackdrop-root {
	  background-color: rgba(0,0,0,0) !important;
	}
`;

export const DialogContent = styled(MuiDialogContent)`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding: 0 !important;
	color: ${props => props.theme.palette.third[100]}
	text-align: center;
	
	h4 {
		font: ${props => props.theme.widthRatio*30}px/${props => props.theme.heightRatio*40}px SFProRounded-Bold;
		margin: 0 0 ${props => props.theme.widthRatio*35}px;
		color: ${props => props.theme.palette.third["100"]};
	}
	
	p {
	  font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Regular;
	  color: ${props => props.theme.palette.third["100"]};
	  margin: 0;
	  
	  &.title {
	    font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Bold;
	  }
	}
	
	.setting-block {
	  width: 100%;
	  
    .secondary-text {
      ${props => props.theme.name === 'dark' && css`
        color: ${props => props.theme.palette.secondary.main};
      `}
      
      ${props => props.theme.name === 'light' && css`
        text-decoration: underline;
      `}
    }
    
    .input {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: ${props => props.theme.widthRatio*12}px;
      
      .label {
        display: inline-block;
      }
    }
    
    .theme-change {
      width: ${props => props.theme.widthRatio * 150}px;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      align-items: center;
      
      img {
        
        &:first-child {
          width: ${props => props.theme.widthRatio * 24}px;
        }
        
        &:last-child {
          width: ${props => props.theme.widthRatio * 29}px;
        }
      }
    }
	}
`;

export const CloseButton = styled(IconButton)`
  padding: 0;
  width: ${props => props.theme.widthRatio * 40}px;
  height: ${props => props.theme.widthRatio * 40}px;
  position: absolute;
  right: ${props => props.theme.widthRatio * 5}px;
  top: ${props => props.theme.widthRatio * 10}px;
  cursor: pointer;
  font: ${props => props.theme.widthRatio*26}px/${props => props.theme.heightRatio*35}px SFProRounded-Bold;
  color: ${props => props.theme.palette.third[100]};
`;

export const IOSSwitch = withStyles(theme => ({
  root: {
    width: theme.widthRatio*65,
    height: theme.widthRatio*34,
    padding: 0,
    margin: theme.spacing(0),
  },
  switchBase: {
    padding: theme.widthRatio*4.3,
    '&$checked': {
      color: theme.palette.third["100"],
      '& + $track': {
        border: `${theme.widthRatio*2}px solid #1F1F1F`,
        backgroundColor: '#F1F1F1',
      },
    }
  },
  thumb: {
    width: theme.widthRatio*26,
    height: theme.widthRatio*26,
  },
  track: {
    borderRadius: theme.widthRatio*16.2,
    border: `${theme.widthRatio*2}px solid #FFFFFF`,
    backgroundColor: 'transparent',
    opacity: '1 !important',
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export const Divider = styled(MuiDivider)`
  width: 100%;
	background-color: ${props => props.theme.name === 'dark' ? '#FFBD5950' : '#1F1F1F50'};
	margin: ${props => props.theme.heightRatio * 30}px
	 				0
	 				${props => props.theme.widthRatio * 25}px;
`;

